<template>
  <q-page padding>   
    <p>{{$t('global.Login')}}</p>
    <hr>
  <q-field  
      :label="$t('global.UserEmail')"
      :helper="$t('global.YourRegistredEmail')"
    >
    <q-input type="text" ref="email" v-model="form.email" @keyup.enter="login"  />
  </q-field>
  <q-field  
      :label="$t('global.Password')"
      :helper="$t('global.PasswordHelper')"
    >
    <q-input type="password" v-model="form.password" @keyup.enter="login" />
  </q-field>
  <hr>
  <q-btn type="submit"  color="primary"  :label="$t('global.Login')" @click="login" :loading="submitting" />
 <hr>

<div class="row">
    <div class="col-4 col-md-2 q-pa-sm">    
      <q-btn outline color="primary" :label="$t('global.German')" @click="language(2)" />
    </div>
    <div class="col-4 col-md-2 q-pa-sm">
      <q-btn outline color="primary" :label="$t('global.French')"  @click="language(3)"/>
    </div>
    <div class="col-4 col-md-2 q-pa-sm">
      <q-btn outline color="primary" :label="$t('global.Italian')"  @click="language(4)"/>
    </div>
    <div class="col-4 col-md-2 q-pa-sm">
      <q-btn outline color="primary" :label="$t('global.English')"  @click="language(1)" />
    </div>
    <div class="col-3 col-md-2 q-pa-sm">
      <q-btn outline color="primary" :label="$t('global.Spanish')"  @click="language(5)" />
    </div>
  </div>
  <div class="row">
    <div class="col q-pa-sm">  
      <q-btn to="signup" outline color="secondary" label="Neues WTracking Konto Eröffnen" /> 
       
    </div>
  </div>


</q-page>
</template>
<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'Login',
  data: function () {
    return {
      alert: false,
      submitting: false,
      form: {
        email: '',
        password: '',
        action: 'Login'
      },
      userData: {
        email: '',
        password: '',
        action: 'Login'
      }
    }
  },
  validations: {
    form: {
      email: { required  },
      password: { required  },
    }
  },
  methods: {
    login () {
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$q.notify(this.$t('global.PleaseCheckEntries'))
        return
      } 
      this.submitting = true
      var isDST = this.moment().isDST()
      var d = new Date();
      var n = d.getTimezoneOffset();
      this.form.TimezoneOffset = n
      this.form.IsDST = isDST //Add DST 
          //this.$cookie.set('idWallet', this.userData.idWallet, 100)
            axios.post(this.$apiUrl,
            qs.stringify(this.form),
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
            .then(response => {
                this.submitting = false
                console.log(response.data)
                console.log(response)
                if(response.status == 200){ 
                    //this.$cookie.set('idWallet', this.userData.idWallet, 100)
                    if(response.data.status == "OK"){
                        //delete this.form.password  //this takes out the password out of the session object
                        this.form.CustomerName = response.data.CustomerName
                        this.form.IdUserCategory = response.data.IdUserCategory
                        this.form.FirstName = response.data.FirstName
                        this.form.LastName = response.data.LastName
                        this.form.SessionId = response.data.SessionId
                        this.form.IdLanguage = response.data.IdLanguage
                        this.form.AccessLevel = response.data.AccessLevel
                        this.form.DateTimeFormat = response.data.DateTimeFormat
                        this.form.StartZoomLevel = response.data.StartZoomLevel
                        this.form.StartLatitude = response.data.StartLatitude
                        this.form.StartLongitude = response.data.StartLongitude
                        if(response.data.IdWorkOpen != null){
                           eventBus.$emit('loadDialogFinishWork', response.data.IdWorkOpen)
                           this.form.NeedsClosing = true
                        }
                        else{
                          this.form.NeedsClosing = false
                        }

                        this.$store.dispatch('setSession', this.form)
                        //eventBus.$emit('loadGeoRegion', null)
                        this.$router.push({name: 'Journal'})
                        
                    }
                    else{
                        this.$q.notify('Wrong Credentials, please review fields again.')
                    }
                }
                else{
                    this.$store.dispatch('setSession', null)
                    this.$q.notify('Something Wrong.')
                }
            })
            .catch(e => {
                this.submitting = false
                if(e.response.status == 403){
                    //this.errors.push(this.translate('LoginError'))
                    this.$q.notify('Something Wrong.')
                }
                console.log(e);
                this.$store.dispatch('setSession', null)
            })
    },
    language(lng){
      var lang = 'de'
      var dateTimeFormat = 'DD.MM.YYYY HH:mm'
      if(lng == 2)
      lang = 'de'
      if(lng == 3)
      lang = 'fr'
      if(lng == 4)
      lang = 'it'
      if(lng == 5)
      lang = 'es'   
      if(lng == 1){
        lang = "en"
        dateTimeFormat = 'MM/DD/YYYY HH:mm'  
      }     
      //Set language for our own translations:
      this.$i18n.locale = lang
      eventBus.$emit('Bus_ChangeLocale', lang)
      //Set language for Quasar
      if(lang == 'en'){
        lang = 'en-us'
      }
      import(`quasar-framework/i18n/${lang}`).then(lang => {
        this.$q.i18n.set(lang.default)
      })
      if(this.$store.state.session != null){
        this.$store.state.session.DateTimeFormat = dateTimeFormat
      }
    }
  },
  mounted: function () {
            //Set user and password for demo site:
            
    },
}
</script>
